import SkeletonRoutineItem from './SkeletonRoutineItem';

interface SkeletonRoutineProps {
  count?: number;
  className?: string;
}

const SkeletonRoutine: React.FC<SkeletonRoutineProps> = ({
  count = 3,
  className
}) => {
  return (
    <div className={`w-full flex flex-col ~gap-2/3 ${className ?? ''}`}>
      {Array.from({ length: count }).map((_, idx) => (
        <SkeletonRoutineItem key={idx} />
      ))}
    </div>
  );
};

export default SkeletonRoutine;
export { default as SkeletonRoutineItem } from './SkeletonRoutineItem';
export { default as SkeletonTiming } from './SkeletonTiming';
export { default as SkeletonCustomRoutineList } from './SkeletonCustomRoutineList';
export { default as SkeletonCustomRoutineItem } from './SkeletonCustomRoutineItem';
export { default as SkeletonHabitPackList } from './SkeletonHabitPackList';
export { default as SkeletonHabitPackCard } from './SkeletonHabitPackCard';
